const navButton = document.querySelector('.js--navigation');
const closeButton = document.querySelector('.js--navigation-close');
const menu = document.querySelector('.full-header-menu');

if (navButton && menu) {
    navButton.addEventListener('click', function() {
        menu.classList.add('open');
    });
}

if (closeButton && menu) {
    closeButton.addEventListener('click', function() {
        menu.classList.remove('open');
    });
}

// ESC nur wenn Menü offen ist
if (menu) {
    document.addEventListener('keydown', function(event) {
        if ((event.key === 'Escape' || event.key === 'Esc') && menu.classList.contains('open')) {
            menu.classList.remove('open');
        }
    });
}
